var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ssp-sidebar"},[(_vm.withLeftSidebar)?_c('div',{staticClass:"sidebar"},[_vm._t("sidebar")],2):_vm._e(),_c('div',{staticClass:"stage",class:{ 'with-sidebar': _vm.withLeftSidebar }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }